import React, { useState, useContext, useEffect } from 'react';
import { colores } from './../../../AppStyle';
import RestProvider from 'providers/RestProvider';
import { properties, texts, msgError, constantesEstadosFasePCT3 } from './AporteDocumentacionData';
import AppContext from 'AppContext';
import { properties as appProperties } from 'AppData';
import { useHistory } from "react-router-dom";
import useApp from 'AppFunctions';
import { properties as propertiesCloudConfig } from 'config/Config';
import { useSelector } from 'react-redux';
import useOperations from 'components/commons/subirArchivo/SubirArchivoFunction';


const useFunctions = () => {

    //Imports
    const { crudOperation, crudOperationsType } = RestProvider();
    const context = useContext(AppContext);
    const history = useHistory();
    const { getMimeType, getTipoSubido, configCargada, getMaxFileSize } = useOperations();

    const PREFIJO_OBJETO_FILE_PDF = 'data:application/pdf;base64,';

    const { obtenerCodigosFaseEstado } = useApp();

    ///Hooks gestion msg errores
    let idAlert = 0;
    const [message, setMessage] = useState({ msg: '', severity: '' });
    const addAlert = msg => setAlerts([...alerts, { id: idAlert++, msg }]);
    const [alerts, setAlerts] = useState([]);
    const handleSetMessage = (msg, severity) => {
        setMessage({ msg, severity });
        addAlert(message);
    }
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);
    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);
    const fase = useSelector((state) => state.kingdomOV3.fase);
    const faseEstadoExpediente = useSelector((state) => state.kingdomOV3.faseEstadoExpediente);
    const accionModificar = useSelector((state) => state.kingdomOV3.accionModificar);
    const accion = useSelector((state) => state.kingdomOV3.accion);

    //Código de aplicación del procedimiento seleccionado
    const codigoAplicacion = procedimientoActual.codigoAplicacion;

    /**
     * @constant isConvocatoriaColaborativa 
     * Evaluando si la convocatoria es colaborativa
     */
    const isConvocatoriaColaborativa = convocatoriaSeleccionada ? convocatoriaSeleccionada.colaborativa : false;


    /**
     * @constant objectButtons Objeto que contiene el valor inicial del hook de estado isVisble.
     * Si se incorporan nuevos botones, habrá que insertar su clave (id) y valor a false. La clave con valor true será el botón seleccionado por defecto.
     */
    const objectButtons = {
        btnObligatorios: true
    }

    // Hooks
    const [infoAnexos, setInfoAnexos] = useState();
    const [listo, setListo] = useState(false);
    const [tituloPagina, setTituloPagina] = useState();
    const [documentos, setDocumentos] = useState([]);
    const [datosTabla, setDatosTabla] = useState([]);
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [isVisible, setIsvisible] = useState(objectButtons); //Contiene un objeto con todos los botones y su estado booleano
    const [numDocumentos, setNumDocumentos] = useState(0);
    const [tamDocumentos, setTamDocumentos] = useState(0);
    const [mostrarPDF, setMostrarPDF] = useState(false);
    const [pdf, setPdf] = useState(null);
    const [mostrarDropZone, setMostrarDropZone] = useState(false);
    const [mostrarDocumentoAnexado, setMostrarDocumentoAnexado] = useState(false);
    const [tamDocumentoVoluntario, setTamDocumentoVoluntario] = useState(0);
    const [documentosVoluntarios, setDocumentosVoluntarios] = useState([]);
    const [numInput, setNumInput] = useState(0);
    const [numAnexosObligatoriosEntregados, setNumAnexosObligatoriosEntregados] = useState(0);
    const [disabledListo, setDisabledListo] = useState(true);
    const [values, setValues] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [tamMaximoSobrepasado, setTamMaximoSobrepasado] = useState(false);
    const [errorDropRejected, setErrorDropRejected] = useState(false);
    const [tamDropRejected, setTamDropRejected] = useState("");
    const [existenAnexosObligatrios, setExistenAnexosObligatrios] = useState(true);
    const [existenAnexosOptativos, setExistenAnexosOptativos] = useState(true);
    const [nombrePdfDescargar, setNombrePdfDescargar] = useState("");
    const [mostrarConfirmacionGuardado, setMostrarConfirmacionGuardado] = useState(false);

    let arrayVoluntariosTmp;

    useEffect(() => {
        if(configCargada){
            arrayVoluntariosTmp = documentosVoluntarios;
        }
    }, [configCargada, documentosVoluntarios]) ;

    const calcularDataSource = (codApp) => {
        let dataSource = null;

        codApp === properties.codigoAplicacionF2 && (dataSource = properties.F2);
        codApp === properties.codigoAplicacionSUB && (dataSource = properties.SUB);

        return dataSource;
    }

    /**
     * @function styleBotonClickado Función que aplica estilo sobre el botón clickado
     * @param {*} botonClickado Valor booleano para saber si se ha clickado o no el botón que corresponde con su id
     * @param {*} idBoton ID del botón que se ha clickado
     */
    const styleBotonClickado = (botonClickado, idBoton) => {
        let backgroundPrimary = colores.principales.fondoEspecifico;
        let colorPrimary = colores.principales.principal;
        let borderColorPrimary = colores.principales.principal;

        let backgroundSecundary = colores.escalaGrises.cero;
        let colorSecundary = colores.escalaGrises.cien;
        let borderColorSecundary = colores.escalaGrises.apoyo;

        //Paso 1. Se aplican los estilos al backgroundColor, color y borderColor
        cambiarEstiloComponente(botonClickado, 'background-color', idBoton, backgroundPrimary, backgroundSecundary);
        cambiarEstiloComponente(botonClickado, 'color', idBoton, colorPrimary, colorSecundary);
        cambiarEstiloComponente(botonClickado, 'border-color', idBoton, borderColorPrimary, borderColorSecundary);
        //Paso 2. Se pone el foco sobre el botón clickado
        document.querySelector(`#${idBoton}`).focus();
    }

    /**
     * @function cambiarEstiloComponente Función auxiliar para cambiar el estilo de un componente si este es clickado
     * @param {*} botonClickado Valor booleano para saber si se ha clickado o no el botón que corresponde con su id
     * @param {*} estilo El estilo que se va a aplicar sobre el componente
     * @param {*} idComponente ID del componente sobre el que se va a cambiar el estilo
     * @param {*} colorPrimary Color primario a aplicar
     * @param {*} colorSecundary Color secundario a aplicar
     */
    const cambiarEstiloComponente = (botonClickado, estilo, idComponente, colorPrimary, colorSecundary) => {
        let color = colorPrimary;
        //Paso 1. Se comprueba si el componente se ha clickado, en caso de que no se establecerá la variable color con otro valor
        !botonClickado && (color = colorSecundary);
        //Paso 2. Se aplica el estilo al componente obtenido a través de su ID
        document.querySelector(`#${idComponente}`).style[estilo] = color;
    }

    /**
     * @function botonPorDefecto Función que establece por defecto el botón seleccionado al cargar la página.
     * Se captura el botón a través de su id, se aplica el evento focus y se establece el estilo por defecto con la función styleBotonClickado.
     * @param {*} id Recibe el id del botón por parámetros
     */
    const botonPorDefecto = (id) => {
        if (id !== undefined && id !== null && id !== 'undefined' && document.querySelector(`#${id}`) !== null) {
            document.querySelector(`#${id}`).focus();
            styleBotonClickado(true, id);
        }
    }

    /**
     * @function getInfoAnexos Obtiene la informacion de los anexos correspondientes
     */
    const getInfoAnexos = async () => {

        //Ponemos a true el loading durante la llamada
        setIsLoading(true);

        if (procedimientoActual.fromPct3) {

            let input = {
                idExpediente: solicitudActual.id,
                idConvocatoria: convocatoriaSeleccionada.id,
                idFase: faseEstadoExpediente.idFase,
                idEstado: faseEstadoExpediente.idEstado,
            }

            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PCT, { url: properties.URL_PCT, method: properties.CRUD_TYPE_POST, data: input }).then(response => {
                setInfoAnexos(response.data);
                response.data !== undefined ? recuperarAnexos(response.data) : setListo(true);

                if (response.data.listAnexosObligatorios.length === 0) {
                    setExistenAnexosObligatrios(false);
                    setDisabledListo(false);
                }
                if (response.data.listAnexosOptativos.length === 0) {
                    setExistenAnexosOptativos(false);
                }
                //setIsLoading(false);
            }).catch(function (error) {
                if (error.response.status !== 404) {
                    handleSetMessage(texts.ERROR, properties.SEVERITY);
                } else {
                    setDisabledListo(false);
                    setListo(true);
                }
                setIsLoading(false);
            });

        } else {
            let idProcedimiento = procedimientoActual.id;
            let idSolicitudPdf = solicitudActual.idMoaddSolicitudPdf;

            let input = {
                dataSource: calcularDataSource(codigoAplicacion),
                idProcedimiento: idProcedimiento,
                nombreFase: fase,
                idSolicitudPdf: idSolicitudPdf
            }
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url: properties.URL, method: properties.CRUD_TYPE_POST, data: input }).then(response => {
                setInfoAnexos(response.data);
                response.data !== undefined ? recuperarAnexos(response.data) : setListo(true);

                if (response.data.listAnexosObligatorios.length === 0) {
                    setExistenAnexosObligatrios(false);
                    setDisabledListo(false);
                }
                if (response.data.listAnexosOptativos.length === 0) {
                    setExistenAnexosOptativos(false);
                }
                if (!response.data.permiteVoluntarios) {

                    let padre = document.querySelector(properties.QUERY_PADRE_BTN_VOL);
                    let botonVoluntario = document.querySelector(properties.QUERY_BTN_VOL);

                    padre.removeChild(botonVoluntario);
                }
                setIsLoading(false);
            }).catch(function (error) {
                if (error.response.status !== 404) {
                    handleSetMessage(texts.ERROR, properties.SEVERITY);
                } else {
                    setDisabledListo(false);
                    setListo(true);
                }
                setIsLoading(false);
            });
        }

        
    }

    /**
     * @function guardarAnexos Función que realiza el guardado de los documentos anexos
     */
    const handleOnClickListo = async () => {
        setIsLoading(true);
        if (listo) {
            if (procedimientoActual.fromPct3) {
                history.push(properties.URL_FIRMA_SOLICITUD);
            } else {
                documentos.length !== 0 && await guardarAnexos();
                history.push(properties.URL_FIRMA_SOLICITUD);
            }
        } else {
            setListo(true); 
            generarDatosTabla();
        }
        setIsLoading(false);
    }

    /**
    * @function guardarAnexos Función que realiza el guardado de los documentos anexos
    */
    const guardarAnexos = async () => {
        let docDto = {
            dataSource: calcularDataSource(codigoAplicacion),
            documentos: documentos,
        }
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ANEXOS, { url: properties.URL_GUARDAR_DOCS, method: properties.CRUD_TYPE_POST, data: docDto }).then(response => {
        }).catch(function (error) {
            handleSetMessage(msgError.error, msgError.severity);
            setIsLoading(true);
        });
    }

     /**
     * @function handleGuardarAnexos Función que realiza el guardado de los anexos, se utiliza en el botón guardar
     */
        const handleGuardarAnexos = async () => {
            setIsLoading(true);
            if (documentos.length !== 0) {
                await guardarAnexos();
            } else {
                setMostrarConfirmacionGuardado(true);
            }
            setIsLoading(false);
        }

    /**
     * @function obtenerTituloPagina obtiene el procedimiento en el que se encuentra para actualizar el
     * titulo de la pagina
     */
    const obtenerTituloPagina = async () => {
        let primeraParte;
        let constantesObtenidas = await obtenerFasesEstados();

        let textNuevaSolicitud = accionModificar ? texts.PAGE_TITLE_MOD : texts.PAGE_TITLE;
        let textSubsanacion = accionModificar ? texts.PAGE_TITLE_SUBSANACION_MOD : texts.PAGE_TITLE_SUBSANACION;
        let textAlegacion = accionModificar ? texts.PAGE_TITLE_ALEGACION_MOD : texts.PAGE_TITLE_ALEGACION;
        let textJustifiacion = accionModificar ? texts.PAGE_TITLE_JUSTIFICACION_MOD : texts.PAGE_TITLE_JUSTIFICACION;

        switch (fase) {
            case constantesObtenidas.F_INICIO_OV3:
                primeraParte = textNuevaSolicitud;
                break;
            case properties.FASE_NUEVA_SOLICITUD:
                primeraParte = textNuevaSolicitud;
                break;
            case constantesObtenidas.F_SUBSANACION_OV3:
                primeraParte = textSubsanacion;
                break;
            case properties.FASE_PENDIENTE_DE_SUBSANAR:
                primeraParte = textSubsanacion;
                break;
            case constantesObtenidas.F_ALEGACIONES_OV3:
                primeraParte = textAlegacion;
                break;
            case properties.FASE_PRESENTACION_ALEGACIONES:
                primeraParte = textAlegacion;
                break;
            case properties.FASE_PENDIENTE_JUSTIFICACION:
                primeraParte = textJustifiacion;
                break;
            case constantesObtenidas.F_JUSTIFICACION_OV3:
                primeraParte = textJustifiacion;
                break;
            default:
                primeraParte = texts.PAGE_TITLE;
                break;
        }

        setTituloPagina(primeraParte + ((procedimientoActual.descripcion === undefined) ? procedimientoActual.nombre : procedimientoActual.descripcion));
        context.updateTitlePage(primeraParte + ((procedimientoActual.descripcion === undefined) ? procedimientoActual.nombre : procedimientoActual.descripcion));
    }


    /**
     * @function handleOnDrop Gestion de la subida de documentos, se almacenan junto con el anexo al que pertenecen
     * @param {*} files Fichero subido por el usuario
     * @param {*} rejectedFiles Fichero rechazado subido por el usuario
     * @param {*} anexoDto Anexo asociado al fichero
     */
    const handleOnDrop = (files, rejectedFiles, anexoDto, id) => {
        if (files.length === 0) return;
        const dropped = files[0];
        const file = dropped.file || dropped; // Si viene como { file, data }, se saca el file; si no, es ya el File
        const tamFicheroSubido = parseFloat((file.size / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES));
        const tamTotal = tamDocumentos + tamFicheroSubido;

        if (infoAnexos.tamMaximoTotal < tamTotal) {
            setTamMaximoSobrepasado(true);
            return;
        } else {
            setTamDocumentos(tamTotal);

            if (anexoDto === null) {
                // Anexos voluntarios
                const fileName = file.name.toLowerCase();
                const extensionFormato = fileName.substring(fileName.lastIndexOf('.') + 1);
                const mimeType = file.type;
                const tipo = getTipoSubido(mimeType);

                let documentoV = {
                    fichero: null,
                    anexo: null,
                    descripcionVoluntario: documentosVoluntarios[numInput].value,
                    firmado: false,
                    nombreFichero: file,
                    idSolicitud: (!procedimientoActual.fromPct3) ? solicitudActual.idMoaddSolicitudPdf : solicitudActual.id,
                    idConvocatoria: convocatoriaSeleccionada.id,
                    idProcedimiento: procedimientoActual.id,
                    extensionFormato: extensionFormato,
                    tamnyoFichero: tamFicheroSubido * 1000, // en kbytes
                };

                if (tipo === "pdf") {
                    // Para PDF se genera base64
                    // Suponiendo que `dropped` tiene una propiedad `data` ya con base64
                    documentoV.fichero = {
                        file: file,
                        data: dropped.data?.split('base64,')[1] || "" // Data con base64
                    };
                } else {
                    // Para imagen/video se pasa el File directamente, sin base64
                    documentoV.fichero = file;
                }

                if (!procedimientoActual.fromPct3) {
                    documentos.push(documentoV);
                }

                guardarAnexoPCT(documentoV, true);
                tratamienoAnexoVoluntario(file.size, file.name);

            } else {
                // Para anexos no voluntarios se asume mismo formato que anexoDto
                handleDropNoVoluntarios(files, anexoDto, id, tamFicheroSubido);
            }
        }
    };

    /**
     * Gestion de la subida de documentos de tipo no voluntario
     * @param {*} files 
     * @param {*} anexoDto 
     * @param {*} id 
     * @param {*} tamFicheroSubido
     */
    const handleDropNoVoluntarios = (files, anexoDto, id, tamFicheroSubido) => {
        let numDocObligatoriosEntregados = numAnexosObligatoriosEntregados;
        for (const anexoObligatorio of infoAnexos.listAnexosObligatorios) {
            if(anexoObligatorio.nombreAnexo === id) {
                anexoObligatorio.mostrarEliminar = true;
                ++numDocObligatoriosEntregados;
                setNumAnexosObligatoriosEntregados(numDocObligatoriosEntregados);
                anexoObligatorio[properties.TAM_DOC_SUB] = tamFicheroSubido;
            }
        }

        if (numDocObligatoriosEntregados === infoAnexos.listAnexosObligatorios.length) {
            setDisabledListo(false);
        }

        for (const anexoOptativos of infoAnexos.listAnexosOptativos) {
            if (anexoOptativos.nombreAnexo === id) {
                anexoOptativos.mostrarEliminar = true;
                anexoOptativos[properties.TAM_DOC_SUB] = tamFicheroSubido;
            }
        }

        // Obtener extensión real del fichero
        const fileName = files[0].file ? files[0].file.name.toLowerCase() : files[0].name.toLowerCase();
        const extensionFormato = fileName.substring(fileName.lastIndexOf('.') + 1);

        let documento = {
            fichero: files[0],
            anexo: anexoDto,
            descripcionVoluntario: null,
            firmado: false,
            nombreFichero: files[0].file ? { ...files[0].file } : null,
            idSolicitud: solicitudActual.idMoaddSolicitudPdf,
            idConvocatoria: convocatoriaSeleccionada.id,
            idProcedimiento: procedimientoActual.id,
            extensionFormato: extensionFormato,
            tamnyoFichero: tamFicheroSubido * 1000,
        };

        // Sólo si es PDF, setear base64
        if (extensionFormato === 'pdf' && files[0].data) {
           documento.fichero.data = files[0].data.split('base64,')[1];
        }

        if (!procedimientoActual.fromPct3) {
            documentos.push(documento);
        } else {
            Object.assign(documento, { idConfAnexo: anexoDto.id });
            guardarAnexoPCT(documento, false);
        }
        setNumDocumentos(numDocumentos + 1);
    }

    /**
     * @function guardarAnexoPCT 
     */
     const guardarAnexoPCT = async (documento, isVoluntario) => {
         if (!procedimientoActual.fromPct3) return;

         let tipoDocVoluntario;
         let codigoDocVol = properties.CODIGO_VOL;

         if (isVoluntario) {
             const mime = (documento.fichero?.type || documento.fichero?.file?.type);
             const tipo = getTipoSubido(mime);
             if (tipo === "imagen") {
                 codigoDocVol = properties.CODIGO_IMAGE_RADA;
             } else if (tipo === "video") {
                 codigoDocVol = properties.CODIGO_VIDEO_RADA;
             }
             tipoDocVoluntario = await recuperarTipoDocVol(codigoDocVol);
         }

         const tipoDocumento = isVoluntario ? tipoDocVoluntario : documento.anexo.tipoDocumento;
         const nombreDocumento = renombrarDocumento(documento, isVoluntario);

         let DocumentoDto = {
             nombre: nombreDocumento,
             descripcion: isVoluntario ? documento.descripcionVoluntario : documento.anexo.descripcionAnexo,
             estadoElaboracion: 'EE_03',
             fechaAries: null,
             idEstado: faseEstadoExpediente.idEstado,
             idFase: faseEstadoExpediente.idFase,
             idExpediente: solicitudActual.id,
             nivelAcceso: 'Libre',
             numeroRegistroEntrada: null,
             tipoCreador: 'ciudadano',
             idConfAnexo: isVoluntario ? null : documento.idConfAnexo,
             datoExpedienteDto: {
                 organismo: {
                     dir3: 'A01025913',
                 },
             },
             organismoDto: null,
             tipoDocumento: {
                 id: tipoDocumento.id,
                 nombre: tipoDocumento.nombre,
                 codigo: tipoDocumento.codigo,
                 descripcion: tipoDocumento.descripcion,
                 origen: tipoDocumento.origen,
                 tiposFormato: tipoDocumento.tiposFormato || documento.extensionFormato,
                 tipoDocumentoEni: tipoDocumento.tipoDocumentoEni
                     ? {
                         id: tipoDocumento.tipoDocumentoEni.id,
                         codigo: tipoDocumento.tipoDocumentoEni.codigo,
                         descripcionCorta: tipoDocumento.tipoDocumentoEni.descripcionCorta,
                     }
                     : null,
                 firmable: true,
                 firmableSello: false,
                 registrable: true,
                 firmaServidor: true,
                 aliasCertificado: tipoDocumento.aliasCertificado
             },
         };

         const isImagenOVideo = [properties.CODIGO_IMAGE_RADA, properties.CODIGO_VIDEO_RADA].includes(tipoDocumento.codigo);
         const recurso = isImagenOVideo ? properties.RESOURCE_ARCHIVO_MULTIMEDIA : properties.RESOURCE_ANEXO_PCT;

         setIsLoading(true);
         let isMounted = true;

         try {
             let requestData;
             if (isImagenOVideo) {
                 // Usamos FormData para imágenes o videos
                 const formData = new FormData();
                 formData.append("documentoDto", new Blob([JSON.stringify(DocumentoDto)], { type: "application/json" }));
                 formData.append("fichero", documento.fichero); // documento.fichero es tipo File

                 requestData = {
                     method: properties.CRUD_TYPE_POST,
                     data: formData,
                     headers: { "Content-Type": "multipart/form-data" }
                 };
             } else {
                 // PDF → base64 en fichero
                 DocumentoDto.fichero = documento.fichero.data;

                 requestData = {
                     method: properties.CRUD_TYPE_POST,
                     data: DocumentoDto
                 };
             }

             const response = await crudOperation(
                 crudOperationsType.CUSTOM,
                 recurso,
                 requestData
             );

             if (!isMounted) return;

             setDocumentos(prevDocs => [...prevDocs, { ...documento, idPCT: response.data.id }]);
             handleSetMessage("Archivo subido correctamente.", 'success');
         } catch (error) {
             if (!isMounted) return;

             handleSetMessage(
                 error.response?.data?.detailedError || "Error inesperado al guardar el archivo.",
                 'error'
             );
             eliminarDocumentoFallido(documento, isVoluntario);
         } finally {
             if (!isMounted) return;
             setIsLoading(false);
         }

         return () => {
             isMounted = false;
         };
     };

     const renombrarDocumento = (documento, isVoluntario) => {
        let nombreDocumento = "sin_nombre.pdf";
                 if (isVoluntario) {
                     if (convocatoriaSeleccionada.renombrarDocumentos) {
                         nombreDocumento = "voluntario_" + documento.descripcionVoluntario
                             .normalize("NFD")                 // Descompone acentos
                             .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
                             .replace(/ñ/g, "n")              // Sustituye la ñ por n
                             .replace(/Ñ/g, "N")                 // Sustituye la Ñ por N
                             .replace(/\s+/g, "_")            // Sustituye espacios por _
                             .replace(/\//g, "_")             // Sustituye / por _
                             .replace(/[\/\\:*?"<>|]/g, "_");

                         if (nombreDocumento.length > 80) {
                             nombreDocumento = nombreDocumento.substring(0, 80);
                         }
                         nombreDocumento += "." + documento.extensionFormato;
                     } else {
                         nombreDocumento = documento.descripcionVoluntario;
                     }
                 } else if (convocatoriaSeleccionada.renombrarDocumentos) {
                     if (documento.anexo.descripcionAnexo) {
                         nombreDocumento = documento.anexo.descripcionAnexo
                             .normalize("NFD")                 // Descompone acentos
                             .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
                             .replace(/ñ/g, "n")              // Sustituye la ñ por n
                             .replace(/Ñ/g, "N")                 // Sustituye la Ñ por N
                             .replace(/\s+/g, "_")            // Sustituye espacios por _
                             .replace(/\//g, "_")             // Sustituye / por _
                             .replace(/[\/\\:*?"<>|]/g, "_");

                         if (nombreDocumento.length > 80) {
                             nombreDocumento = nombreDocumento.substring(0, 80);
                         }
                         nombreDocumento += "." + documento.extensionFormato;
                     } else {
                         nombreDocumento = "sin_nombre_34784387.pdf";
                     }
                 } else {
                     nombreDocumento =  documento?.fichero?.file?.path ?? documento?.fichero?.path;
                 }
           return nombreDocumento;
     }

     /**
      * Elimina un documento fallido de la lista correspondiente (voluntarios u obligatorios/optativos)
      * y actualiza los estados relacionados como el tamaño total, inputs visibles y contador de anexos.
      *
      * @function eliminarDocumentoFallido
      * @param {Object} documento - Objeto del documento que falló al guardarse.
      * @param {boolean} isVoluntario - Indica si el documento es voluntario.
      */
     const eliminarDocumentoFallido = (documento, isVoluntario) => {
        if (isVoluntario) {
            let arrayTemp = [...documentosVoluntarios];

             for (let i = 0; i < arrayTemp.length; i++) {
                if (documento.descripcionVoluntario === arrayTemp[i].value) {
                    // Calcular y actualizar tamaño total
                    let parseTamDocu = parseFloat(arrayTemp[i].tamDoc || "0");
                    let tamDocu = parseTamDocu.toFixed(properties.NUMERO_DECIMALES);
                    setTamDocumentos(prevTam => parseFloat((prevTam - tamDocu).toFixed(properties.NUMERO_DECIMALES)));
                    arrayTemp.splice(i, 1);

                    let documentoVoluntario = {
                        id: Date.now(),
                        mostrarDropZone: false,
                        value: "",
                        mostrarDocAnexo: false,
                        tamDoc: "",
                        img: properties.PATH_IMG_PDF
                    }

                    arrayTemp.push(documentoVoluntario);
                    setNumInput(arrayTemp.length-1);
                    setDocumentosVoluntarios(arrayTemp);

                    if (numAnexosObligatoriosEntregados === infoAnexos.listAnexosObligatorios.length) {
                        setDisabledListo(false);
                    }
                    break;
                }
            }

            // También eliminar de documentos[]
            for (let j = 0; j < documentos.length; j++) {
                if (documentos[j].descripcionVoluntario === documento.descripcionVoluntario) {
                    documentos.splice(j, 1);
                    break;
                }
            }

        } else {
             // Anexo obligatorio u optativo
             let eliminado = false;

             setNumAnexosObligatoriosEntregados(prev => {
                 let nuevoNum = prev;
                 for (let doc of infoAnexos.listAnexosObligatorios) {
                     if (doc.nombreAnexo === documento.anexo.nombreAnexo) {
                         doc.mostrarEliminar = false;
                         nuevoNum = prev - 1;
                         eliminado = true;
                         break;
                     }
                 }
                 if (eliminado) {
                     setDisabledListo(true);
                 }
                 return nuevoNum;
             });

             // Actualizar tamaño documentos y contador general solo si eliminado
             if (eliminado) {
                 const sizeBytes = documento?.fichero?.file?.size ?? documento?.fichero?.size ?? 0;
                 const tamDocuActual = parseFloat((sizeBytes / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES));
                 setTamDocumentos(prev => parseFloat((prev - tamDocuActual).toFixed(properties.NUMERO_DECIMALES)));
                 setNumDocumentos(prev => prev - 1);
             }

             for (let doc of infoAnexos.listAnexosOptativos) {
                 if (doc.nombreAnexo === documento.anexo.nombreAnexo) {
                     doc.mostrarEliminar = false;
                     break;
                 }
             }
         }
     };


    /**
     * @function generarDatosTabla Monta los objetos necesarios para la tabla a partir de la informacion
     * de los documentos subidos y los anexos a los que pertenecen
     */
    const generarDatosTabla = () => {
        documentos.forEach(documento => {
            let tipo, nombre, identificador;
            if (documento.anexo === null || documento.anexo.length === 0) {
                nombre = documento.descripcionVoluntario;
                identificador = documento.descripcionVoluntario;
                tipo = properties.TIPO_VOLUNTARIO;
            } else {
                nombre = documento.anexo.descripcionAnexo
                identificador = documento.anexo.nombreAnexo

                let tipoTmp = documento.anexo.obligatorioAnexo
                if (tipoTmp != null && tipoTmp.length > 0) {
                    if (tipoTmp.toUpperCase() === properties.NO) {
                        tipo = properties.TIPO_OPTATIVO;
                    } else {
                        tipo = properties.TIPO_OBLIGATORIO
                    }
                }
            }
            const pathArchivo = documento?.nombreFichero?.path
                             ?? documento?.nombreFichero?.File?.path;
            const esPdf = pathArchivo?.endsWith('.pdf') ?? false;
            guardarFila(identificador, nombre, tipo, esPdf);
        });
        arrayVoluntariosTmp = documentosVoluntarios;
    }

    /**
     * @function guardarFila crea y añade a la tabla una nueva fila
     * @param {*} identificador del anexo
     * @param {*} nombre del anexo
     * @param {*} tipo de anexo, obligatorio, optativo o voluntario
     * @param {*} esPdf si el documento es Pdf o un archivo multimedia
     */
    const guardarFila = (identificador, nombre, tipo, esPdf) => {
        let fila;

        if (isConvocatoriaColaborativa && perfilSeleccionado.descripcion === 'REPRESENTANTE_SICA' && !convocatoriaSeleccionada.repreAnexos && (accion === 'revisarPresentacion' || accion === 'revisarSubsanacion' || accion === 'revisarAlegacion')) {

            fila = {
                identificador: identificador,
                nombre: nombre,
                estado: properties.ESTADO_ANEXO,
                tipo: tipo,
                acciones: [
                    {
                        img: properties.RUTA_IMG_LUPA,
                        funcion: visualizarAnexoDesdeTabla,
                        titulo: properties.TITULO_LUPA,
                    }
                ]
            }
        }else if(esPdf){
            fila = {
                identificador: identificador,
                nombre: nombre,
                estado: properties.ESTADO_ANEXO,
                tipo: tipo,
                acciones: [
                    {
                        img: properties.RUTA_IMG_BORRAR,
                        funcion: deleteAnexoDesdeTabla,
                        titulo: properties.TITULO_ELIMINAR,
                    },
                    {
                        img: properties.RUTA_IMG_LUPA,
                        funcion: visualizarAnexoDesdeTabla,
                        titulo: properties.TITULO_LUPA,
                    }
                ]
            }
        }else{
            fila = {
                identificador: identificador,
                nombre: nombre,
                estado: properties.ESTADO_ANEXO,
                tipo: tipo,
                acciones: [
                    {
                        img: properties.RUTA_IMG_BORRAR,
                        funcion: deleteAnexoDesdeTabla,
                        titulo: properties.TITULO_ELIMINAR,
                    },
                    {
                        img: properties.RUTA_IMG_DESCARGA,
                        funcion: visualizarAnexoDesdeTabla,
                        titulo: properties.TITULO_DESCARGAR,
                    }
                ]
            }
        }

        datosTabla.push(fila);
    }

    /**
     * @function updateFormat Segun el num de pixeles del ancho de la pantalla pone version movil o version ordenador
     */
    const updateFormat = () => {
        if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    }

    /**
     * @function deleteAnexoDesdeTabla boton borrar de la tabla de visualizacion de documentos subidos,
     * elimina el documento, la fila de la tabla y el objeto que gestiona en el caso de ser voluntario
     * que coincida con el identificador
     * @param {*} identificador campo por el que se elimina
     */
    const deleteAnexoDesdeTabla = (e, identificador) => {
        //Borrar de tabla
        let i = 0;
        let encontradoTabla = false;
        while (i < datosTabla.length && !encontradoTabla) {
            if (datosTabla[i].identificador === identificador) {
                datosTabla.splice(i, 1);
                encontradoTabla = true;
            }
            i++;
        }

        let voluntario = borrarDocumentoPorIdentificador(identificador);
        if (voluntario) {
            borrarAnexoVoluntarioPorIdentificador(identificador);
        }
    }

    /**
     * @function borrarDocumentoPorIdentificador elimina de la coleccion de
     * documentos el que coincida con el identificador y actualiza todos los
     * campos relacionados con el borrado del documento
     * @param {*} identificador campo por el que se borra el documento
     */
    const borrarDocumentoPorIdentificador = (identificador) => {
        let i = 0;
        let voluntario = false;
        let encontrado = false;

        while (i < documentos.length && !encontrado) {
            let documento = documentos[i];

            if ((documento.anexo !== null && documento.anexo.nombreAnexo === identificador)
                || documento.descripcionVoluntario === identificador) {

                let convert = parseFloat((documento.fichero.file.size / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES));
                let tamDocu = parseFloat((tamDocumentos - convert).toFixed(properties.NUMERO_DECIMALES));
                setTamDocumentos(tamDocu);

                if (documento.anexo !== null) {
                    setNumDocumentos(calcularNumDocNoVoluntarios() - 1);
                } else {
                    voluntario = true;
                }

                if (documento.anexo !== null) {
                    resetearAnexo(documento, identificador);
                }
                if (procedimientoActual.fromPct3) {
                    setIsLoading(true);
                    crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ANEXO_PCT, { url: properties.RESOURCE_ELIMINAR_ANEXO_PCT + documentos[i].idPCT, method: properties.CRUD_TYPE_GET }).then(response => {
                        setIsLoading(false);
                    })
                }

                encontrado = true;
                documentos.splice(i, 1);
            }
            i++;
        }
        return voluntario;
    }

    /**
     * Resetea el aspecto visual de los anexos obligatorios y optativos
     * en la sección de añadir anexo para mostras de nuevo el dropzone y 
     * quitar el boton eliminar
     * @param {*} documento documento en cuestion
     * @param {*} identificador parametro por el que se busca el documento
     */
    const resetearAnexo = (documento, identificador) => {
        let i = 0;
        let j = 0;
        let anexoReseteado = false;

        if (documento.anexo.obligatorioAnexo.toUpperCase() === properties.NO) {
            while (j < infoAnexos.listAnexosOptativos.length && !anexoReseteado) {
                if (infoAnexos.listAnexosOptativos[j].nombreAnexo === identificador) {
                    infoAnexos.listAnexosOptativos[j].mostrarEliminar = false;
                    anexoReseteado = true;
                }
                j++;
            }
        } else {
            while (i < infoAnexos.listAnexosObligatorios.length && !anexoReseteado) {
                if (infoAnexos.listAnexosObligatorios[i].nombreAnexo === identificador) {
                    infoAnexos.listAnexosObligatorios[i].mostrarEliminar = false;
                    setNumAnexosObligatoriosEntregados(calcularNumDocObligatorios() - 1)
                    anexoReseteado = true;
                    setDisabledListo(true);
                }
                i++;
            }
        }
    }

    /**
     * @function borrarAnexoVoluntarioPorIdentificador borrado del anexo voluntario del array que gestiona
     * los anexos voluntarios por el identificador
     * @param {*} identificador campo por el que se borra el anexo
     */
    const borrarAnexoVoluntarioPorIdentificador = (identificador) => {
        let x = 0;
        let encontradoVoluntario = false;

        if (arrayVoluntariosTmp) {
            while (x < arrayVoluntariosTmp.length && !encontradoVoluntario) {
                if (identificador === arrayVoluntariosTmp[x].value) {
                    setNumInput(calcularNumeroInputs() - 1)
                    arrayVoluntariosTmp.splice(x, 1);
                    setDocumentosVoluntarios(arrayVoluntariosTmp);
                    encontradoVoluntario = true;
                }
                x++;
            }
        }
    }

    /**
     * TMP: Los hooks no se actualizan correctamente
     * @function calcularNumDocNoVoluntarios
     * @returns numDocNoVol numero de documentos no volunatrios subidos actualmente
     */
    const calcularNumDocNoVoluntarios = () => {
        let numDocNoVol = 0;
        for (let doc of documentos) {
            if (doc.anexo !== null) {
                numDocNoVol++;
            }
        }
        return numDocNoVol;
    }

    /**
     * TMP: Los hooks no se actualizan correctamente
     * @function calcularNumDocObligatorios
     * @returns numDocObl numero de documentos obligatorios subidos actualmente
     */
    const calcularNumDocObligatorios = () => {
        let numDocObl = 0;
        for (let doc of documentos) {
            if (doc.anexo !== null) {
                if (doc.anexo.obligatorioAnexo.toUpperCase() !== properties.NO) {
                    numDocObl++;
                }
            }
        }
        return numDocObl;
    }

    /**
     * TMP: Los hooks no se actualizan correctamente
     * @function calcularTamDocumentos
     * @returns tamDocs calcula el peso total de los archivos subidos actualmente
     */
    const calcularTamDocumentos = () => {
        let tamDocs = 0;
        for (let doc of documentos) {
            tamDocs = tamDocs + parseFloat((doc.fichero.file.size / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES));
        }
        return tamDocs;
    }

    /**
     * TMP: Los hooks no se actualizan correctamente
     * @function calcularNumeroInputs
     * @returns numInputs calcula el numero total de inputs actuales en
     * la seccion de subir archivos voluntarios
     */
    const calcularNumeroInputs = () => {
        let numInputs = 0;
        if (documentosVoluntarios) {
            for (let i = 0; i < documentosVoluntarios.length; i++) {
                numInputs = i;
            }
        }
        return numInputs;
    }

    /**
     * @function buttonsState Función auxiliar utilizada para establecer el estado de los botones del menú de navegación y su estilo.
     * @param {*} idBtnClickado Recibe el id del botón que se ha clickado
     */
    const buttonsState = (idBtnClickado) => {
        // Paso 1. Se obtienem las keys del objeto objectButtons                        
        let keysObjectButtons = Object.keys(isVisible);
        //Paso 2. Se recorre el objeto keysObjectButtons
        for (const idButton of keysObjectButtons) {
            //Paso 3. Se inserta el valor false a todos las keys que no correspondan con el id del botón clickado para reinicializar los valores.
            if (idBtnClickado !== idButton) {
                isVisible[idButton] = false;
                //Paso 3.1. Se reinicializan los estilos de los botones
                styleBotonClickado(false, idButton);
            }
        }
        //Paso 4. Se inserta el valor true para la hook visible que corresponda con el botón clickado
        setIsvisible({
            ...isVisible,
            [idBtnClickado]: true
        });
        //Paso 4.1. Se inserta el estilo al botón clickado
        styleBotonClickado(true, idBtnClickado);
    }

    /**
     * @function handleChangeIsVisible Función para manejar el cambio de estado de la hook visible
     * @param {*} e Recibe el evento por parámetros
     */
    const handleChangeIsVisible = (e) => {
        //Paso 1. Se obtiene el id del botón clickado
        let idBoton = e.currentTarget.id;
        //Paso 2. Se llama a la función buttonState y se introduce por parámetros el id del botón clickado
        buttonsState(idBoton);
    }

    /**
     * @function visualizarAnexoDesdeTabla mostrar pdf seleccionado en un pop up, si no es un pdf
     * lo descarga
     * @param {*} e evento onClick del boton
     * @param {*} identificador campo por el que identificar los anexos
     */
    const visualizarAnexoDesdeTabla = async (e, identificador) => {
        for (const documento of documentos) {
            let idDocumento = documento.anexo === null
                ? documento.descripcionVoluntario
                : documento.anexo.nombreAnexo;
            if (idDocumento === identificador) {
                const nombreFichero = documento.nombreFichero.path;
                const extension = nombreFichero.split('.').pop().toLowerCase();
                const dataBase64 = documento.fichero?.data;

                if(dataBase64){
                    if (extension === texts.PDF) {
                        const file = PREFIJO_OBJETO_FILE_PDF + dataBase64;
                        setNombrePdfDescargar(nombreFichero);
                        setPdf(file);
                        setMostrarPDF(true);
                    } else {
                        try {
                            const mime = getMimeType('.' + extension);
                            const byteCharacters = atob(dataBase64);
                            const byteLength = byteCharacters.length;
                            const byteArray = new Uint8Array(byteLength);

                            for (let i = 0; i < byteLength; i++) {
                                byteArray[i] = byteCharacters.charCodeAt(i);
                            }

                            const blob = new Blob([byteArray], { type: mime });
                            const url = window.URL.createObjectURL(blob);

                            const link = document.createElement(properties.ELEMENTO_DESCARGA);
                            link.href = url;
                            link.download = nombreFichero;
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            window.URL.revokeObjectURL(url); // libera la URL después de usarla
                        } catch (error) {
                            console.error('Error al descargar el archivo:', error);
                        }
                    }
                } else {
                  // Si no hay base64, llama al backend para obtener Blob
                  await descargarDesdeBackend(documento.idPCT, nombreFichero);
                }

                break; // Salimos del bucle tras encontrar el documento
            }
        }
    };

    async function descargarDesdeBackend(idDoc, nombreFichero) {
      try {
        const endpoint = `${properties.RESOURCE_DESCARGAR_MULTIMEDIA.replace('{idDoc}', idDoc)}`;
        const respuesta = await crudOperation(
          crudOperationsType.CUSTOM,
          properties.RESOURCE_ARCHIVO_MULTIMEDIA,
          {
            url: endpoint,
            method: properties.CRUD_TYPE_GET,
            responseType: 'blob',
            timeout: 300000 //5 minutos
          }
        );
        if (respuesta.status < 200 || respuesta.status >= 300) {
             throw new Error('Error al descargar fichero');
        }

        const blob = respuesta.data;
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement(properties.ELEMENTO_DESCARGA);
        link.href = url;
        link.download = nombreFichero;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        alert('No se pudo descargar el archivo');
      }
    }

    /**
     * @function cerrarPopUpPdf Actualiza el hook que controla el pop up para visualizar pdfs y lo cierra
     */
    const cerrarPopUpPdf = () => {
        setMostrarPDF(false);
    }

    //Metodo que controla el INPUT del componente SubidaArchivoVoluntario para mostrar el Dropzone
    const handleChange = (e) => {
        setValues(e.target.value);
        documentosVoluntarios[numInput].value = e.target.value;

        if (e.target.value === null || e.target.value === undefined || e.target.value === "") {
            documentosVoluntarios[numInput].mostrarDropZone = false;
        } else {

            if (numInput !== 0) {
                for (var j = 0; j < documentosVoluntarios.length - 1; j++) {
                    if (documentosVoluntarios[j].value === e.target.value) {
                        const arrayTemp = [...documentosVoluntarios];
                        arrayTemp[numInput].mostrarDropZone = false;
                        setDocumentosVoluntarios(arrayTemp);
                        break;
                    } else {
                        documentosVoluntarios[numInput].mostrarDropZone = true;
                    }
                }
            } else {
                documentosVoluntarios[numInput].mostrarDropZone = true;
            }
        }

    };

    //Metodo que controla el INPUT del componente SubidaArchivoVoluntario para mostrar el Dropzone
    const eliminarAnexoVoluntario = (e) => {

        const arrayTemp = [...documentosVoluntarios];

        for (var i = 0; i < arrayTemp.length; i++) {
            if (e.target.name === arrayTemp[i].value) {
                let parseTamDocu = parseFloat(arrayTemp[i].tamDoc);
                let tamDocu = parseTamDocu.toFixed(properties.NUMERO_DECIMALES);
                let tamDocuTotal = parseFloat((tamDocumentos - tamDocu).toFixed(properties.NUMERO_DECIMALES));

                setTamDocumentos(tamDocuTotal);
                arrayTemp.splice(i, 1);
                setDocumentosVoluntarios(arrayTemp);
                setNumInput(numInput - 1);
                if (numAnexosObligatoriosEntregados === infoAnexos.listAnexosObligatorios.length) {
                    setDisabledListo(false);
                }

            }
        }

        for (var j = 0; j < documentos.length; j++) {
            if (e.target.name === documentos[j].descripcionVoluntario) {
                if (procedimientoActual.fromPct3) {
                    setIsLoading(true);
                    crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ANEXO_PCT, { url: properties.RESOURCE_ELIMINAR_ANEXO_PCT + documentos[j].idPCT, method: properties.CRUD_TYPE_GET }).then(response => {
                        setIsLoading(false);
                    })
                }
                documentos.splice(j, 1);
            }
        }

    };

    //Metodo que crea un nuevo registro en el array voluntarios
    const tratamienoAnexoVoluntario = (pesoDoc, nombreFichero) => {

            documentosVoluntarios[numInput].mostrarDocAnexo = true;
            documentosVoluntarios[numInput].tamDoc = (pesoDoc / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES);    
            documentosVoluntarios[numInput].img = obtenerIconoDocVoluntarios(nombreFichero);
            const arrayTemp = [...documentosVoluntarios];

            setNumInput(numInput + 1);
            let documentoVoluntario = {
                id: Date.now(),
                mostrarDropZone: false,
                value: "",
                mostrarDocAnexo: false,
                tamDoc: "",
                img: properties.PATH_IMG_PDF
            }

        arrayTemp.push(documentoVoluntario);
        setDocumentosVoluntarios(arrayTemp);
    };

    //Metodo que crea una nueva clave valor para controlar si el usuario ha subido un anexo y mostrar el boton eliminar
    const anyadirPropiedadEliminar = () => {
        if (infoAnexos) {

            for (const anexoObligatorio of infoAnexos.listAnexosObligatorios) {
                anexoObligatorio[properties.MOSTRAR_ELIMINAR] = false;
            }

            for (const anexoOptativo of infoAnexos.listAnexosOptativos) {
                anexoOptativo[properties.MOSTRAR_ELIMINAR] = false;
            }
        }
    };

    //Metodo que elimina el anexo y cambia la variable para volver a mostrar el dropzone
    const eliminarAnexo = (e) => {
        var numDocObligatorios = numAnexosObligatoriosEntregados;

        for (let doc of infoAnexos.listAnexosObligatorios) {
            if (doc.nombreAnexo === e.target.name) {
                doc.mostrarEliminar = false;
                --numDocObligatorios;
                setNumAnexosObligatoriosEntregados(numDocObligatorios);
                setDisabledListo(true);
            }
        }

        for (let doc of infoAnexos.listAnexosOptativos) {
            if (doc.nombreAnexo === e.target.name) {
                doc.mostrarEliminar = false;
            }
        }

        for (var j = 0; j < documentos.length; j++) {
            if (documentos[j].anexo !== null) {
                if (e.target.name === documentos[j].anexo.nombreAnexo) {
                    if (numDocObligatorios === infoAnexos.listAnexosObligatorios.length) {
                        setDisabledListo(false);
                    }
                    const fichero = documentos[j].fichero?.file ?? documentos[j].fichero;
                    const tamDocuActual = fichero && fichero.size
                      ? parseFloat((fichero.size / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES))
                      : 0;
                    let tamDocu = parseFloat((tamDocumentos - tamDocuActual).toFixed(properties.NUMERO_DECIMALES));
                    setTamDocumentos(tamDocu);

                    if (procedimientoActual.fromPct3) {
                        setIsLoading(true);
                        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ANEXO_PCT, { url: properties.RESOURCE_ELIMINAR_ANEXO_PCT + documentos[j].idPCT, method: properties.CRUD_TYPE_GET }).then(response => {
                            setIsLoading(false);
                        })

                    }

                    documentos.splice(j, 1);

                    break;
                }
            }
        }

        setNumDocumentos(numDocumentos - 1);

    };

    //Metodo que te lleva al paso anterior, en este caso a formulario
    const atrasFormulario = () => {
        history.push(properties.URL_CREATE_NUEVA_SOLICITUD);
    };

    //Metodo que oculta la tabla y muestra subir archivos (en caso de que existan anexos). En caso de que no existan anexos retorna a la pantalla nueva solicitud
    const atrasOcultarTabla = () => {
        if (infoAnexos !== undefined && infoAnexos !== '') {
            if (numAnexosObligatoriosEntregados !== infoAnexos.listAnexosObligatorios.length) {
                setDisabledListo(true);
            }
            setListo(false);
            setDatosTabla([]);
        } else {
            history.push('/NuevaSolicitud');
        }
    };

    //Metodo que cierra el componente confirmar que salta al añadirmas peso de lo permitido
    const cerrarConfirmarPeso = () => {
        setTamMaximoSobrepasado(false);
    };

    // Metodo que hace saltar el componente mostrar cuando un anexo subido es rechazado
    const mostrarConfirmarError = (rejectedFile, tamMaxDoc, descripcionArchivo, setTipoArchivoRechazado) => {
        setErrorDropRejected(true);
        let tipoArchivo = 'pdf'; // Valor por defecto
        let tamMaxFicheroMB = tamMaxDoc;
        if (descripcionArchivo.toLowerCase().includes("video")) {
            tipoArchivo = 'video';
        } else if (descripcionArchivo.toLowerCase().includes("foto")) {
            tipoArchivo = 'foto';
        } else if (descripcionArchivo.includes("anexoV")) {
            // Si es anexoV y no tenemos claro el tipo, lo miramos por mime
            if (rejectedFile && rejectedFile.length > 0) {
                const file = rejectedFile[0].file? rejectedFile[0].file : rejectedFile[0];
                //Tamaño maximo fichero en MB
                const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
                const maxSize = getMaxFileSize(ext, tamMaxDoc);
                let bytesToMB = tamMaxDoc;
                //Mimetype
                const mime = file.type.toLowerCase();
                if (mime.includes("video")) {
                    tipoArchivo = "video";
                    bytesToMB =  maxSize / (1024 * 1024);
                } else if (mime.includes("image")) {
                    tipoArchivo = "foto";
                    bytesToMB =  maxSize / (1024 * 1024);
                } else if (mime.includes("pdf")) {
                    tipoArchivo = "pdf";
                }
                else{
                   tipoArchivo = "no-valido";
                }
                tamMaxFicheroMB = bytesToMB;
            }
        }
        setTamDropRejected(tamMaxFicheroMB);
        // Se guarda SIEMPRE el tipo de archivo rechazado
        setTipoArchivoRechazado(tipoArchivo);
    };

    //Metodo que cierra el componente mostrar cuando un anexo subido es rechazado
    const cerrarErrorDropRejected = () => {
        setErrorDropRejected(false);
    };

    const cerrarConfirmacionGuardado = () => {
        setMostrarConfirmacionGuardado(false);
    }

    //Metodo que consulta en la base de datos si la solicitud tiene anexos entregados, en caso de que exista rellenaremos la pagina
    const recuperarAnexos = async (informacionAnexos) => {
        setIsLoading(true);

        let input = {
            dataSource: calcularDataSource(codigoAplicacion),
            idSolicitud: solicitudActual.idMoaddSolicitudPdf,
            idProcedimientos: null,
        }
        const docsEnform = [];
        const docsEnBD = [];

        if (procedimientoActual.fromPct3) {
            const request = {
                'idExpediente': solicitudActual.id,
                ...faseEstadoExpediente
            }
            let arrayTempVoluntariosIds = []; //Array temporal para guardar los ids de los docs voluntarios, para que no se eliminen posteriormente
            let arrayTempOptativosIds = [];

            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ANEXO_PCT, { url: properties.RESOURCE_OBTENER_ANEXO_PCT, method: properties.CRUD_TYPE_POST, data: request }).then(response => {

                let numAnexosObligatorios = 0;
                let numAnexosAnexar = 0;
                const arrayTempVoluntarios = [];
                let contieneAnexosVoluntarios = false;
                let numInputsCreados = numInput;
                let pesoDocumentosTotal = 0;

                for (const docAnexo of response.data) {
                    docsEnBD.push(docAnexo.documento.id); //Se guardan todos los recuperados en este array

                    let tamFichero = parseFloat((docAnexo.tamAnexo / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES));

                    pesoDocumentosTotal = pesoDocumentosTotal + tamFichero;

                    // Función para normalizar el texto igual que en el backend
                    const normalizeString = (str) => {
                        if (!str) return "";

                        const regex = /[!¡\*'()';:@&=+\$,/¿%#\[\]_.~]/g;

                        return str
                            .replaceAll(regex, "-")
                            .replaceAll(" ", "-")
                    };
                    // Los documentos "Depende del campo del formulario" se han de gestionar igual que los obligatorios en este punto
                    if (docAnexo.confAnexo.obligatorio === "Si" || docAnexo.confAnexo.obligatorio === "Depende del campo del formulario") {
                        numAnexosObligatorios++;

                        for (const infoAnexoObligatorio of informacionAnexos.listAnexosObligatorios) {

                            if (docAnexo.documento.descripcion === normalizeString(infoAnexoObligatorio.descripcionAnexo)) {
                                docsEnform.push(docAnexo.documento.id);

                                Object.assign(infoAnexoObligatorio, { mostrarEliminar: true });
                                Object.assign(infoAnexoObligatorio, { tamDocSubido: tamFichero }); //PESO DEL DOC

                                let documentoV = {
                                    fichero: {
                                        data: docAnexo.fichero,
                                        file: {
                                            path: docAnexo.documento.nombre,
                                            size: docAnexo.tamAnexo //<---- Pongo el tamaño a 0 ya que no lo guardamos
                                        }
                                    },
                                    anexo: infoAnexoObligatorio,
                                    descripcionVoluntario: null,
                                    firmado: false,
                                    nombreFichero: {
                                        path: docAnexo.documento.nombre,
                                    },
                                    idSolicitud: solicitudActual.id,
                                    idConvocatoria: convocatoriaSeleccionada.id,
                                    idProcedimiento: procedimientoActual.id,
                                    idPCT: docAnexo.documento.id,
                                }

                                documentos.push(documentoV);

                            }

                        }


                    } else if (docAnexo.confAnexo.obligatorio === "No") {
                        numAnexosAnexar++;

                        for (const infoAnexoOptativo of informacionAnexos.listAnexosOptativos) {

                            if (docAnexo.documento.descripcion === normalizeString(infoAnexoOptativo.descripcionAnexo)) {

                                Object.assign(infoAnexoOptativo, { mostrarEliminar: true });
                                Object.assign(infoAnexoOptativo, { tamDocSubido: tamFichero }); //PESO DEL DOC

                                let documentoV = {
                                    fichero: {
                                        data: docAnexo.fichero,
                                        file: {
                                            path: docAnexo.documento.nombre,
                                            size: docAnexo.tamAnexo, //<---- Pongo el tamaño a 0 ya que no lo guardamos
                                        }
                                    },
                                    anexo: infoAnexoOptativo,
                                    descripcionVoluntario: null,
                                    firmado: false,
                                    nombreFichero: {
                                        path: docAnexo.documento.nombre,
                                    },
                                    idSolicitud: solicitudActual.id,
                                    idConvocatoria: convocatoriaSeleccionada.id,
                                    idProcedimiento: procedimientoActual.id,
                                    idPCT: docAnexo.documento.id,
                                }

                                documentos.push(documentoV);

                                arrayTempOptativosIds.push(docAnexo.documento.id);

                            }

                        }
                    } else {

                        let documentoV = {
                            fichero: {
                                data: docAnexo.fichero,
                                file: {
                                    path: docAnexo.documento.nombre,
                                    size: docAnexo.tamAnexo, //<---- Pongo el tamaño a 0 ya que no lo guardamos
                                },
                            },
                            anexo: null,
                            descripcionVoluntario: docAnexo.documento.descripcion,
                            firmado: false,
                            nombreFichero: {
                                path: docAnexo.documento.nombre,
                            },
                            idSolicitud: solicitudActual.id,
                            idConvocatoria: convocatoriaSeleccionada.id,
                            idProcedimiento: procedimientoActual.id,
                            idPCT: docAnexo.documento.id,
                        }

                        documentos.push(documentoV);
                        contieneAnexosVoluntarios = true
                        let iconoDocVol= obtenerIconoDocVoluntarios(docAnexo.documento.nombre);
                        numInputsCreados++;
                        let documentoVoluntario = {
                            id: docAnexo.documento.id,
                            mostrarDropZone: true,
                            value: docAnexo.documento.descripcion,
                            mostrarDocAnexo: true,
                            tamDoc: tamFichero,
                            img: iconoDocVol
                        }

                        arrayTempVoluntarios.push(documentoVoluntario);
                        arrayTempVoluntariosIds.push(docAnexo.documento.id);

                    }

                }
                numAnexosObligatorios = docsEnform.length;
                setTamDocumentos(parseFloat(pesoDocumentosTotal.toFixed(properties.NUMERO_DECIMALES)));
                setNumAnexosObligatoriosEntregados(numAnexosObligatorios);
                setNumDocumentos(numAnexosObligatorios + numAnexosAnexar)
                setInfoAnexos(informacionAnexos);

                if (contieneAnexosVoluntarios) {
                    let documentoVoluntario = {
                        id: Date.now(),
                        mostrarDropZone: false,
                        value: "",
                        mostrarDocAnexo: false,
                        tamDoc: "",
                        img: properties.PATH_IMG_PDF
                    }
                    arrayTempVoluntarios.push(documentoVoluntario);
                    setNumInput(numInputsCreados);
                    setDocumentosVoluntarios(arrayTempVoluntarios);
                }

                if (informacionAnexos.listAnexosObligatorios.length === numAnexosObligatorios) {
                    setDisabledListo(false);
                }



            }).finally(function () {
                let convocatoriasColaborativas = propertiesCloudConfig['CONVOCATORIAS_COLABORATIVAS_CODIGO'];
                let convocatoriasObtenidas = convocatoriasColaborativas !== undefined ? convocatoriasColaborativas.split(', ') : null;

                //Se eliminaban los docs voluntarios, se crea array con todos para tenerlos en cuenta a la hora de combinar
                const docsTotales = [
                    ...arrayTempOptativosIds,
                    ...arrayTempVoluntariosIds,
                    ...docsEnform
                ];
                const combinados = [...new Set([...docsEnform, ...docsEnBD])];

                //Si no estan en ambos arrays se usan para borrar para no generar docs indeseados
                const noCoincidentes = combinados.filter(
                    elemento =>
                        (docsTotales.includes(elemento) && !docsEnBD.includes(elemento)) ||
                        (docsEnBD.includes(elemento) && !docsTotales.includes(elemento))
                );

                if (noCoincidentes.length > 0) {
                    for (const idDoc of noCoincidentes) {
                        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ANEXO_PCT, { url: properties.RESOURCE_ELIMINAR_ANEXO_PCT + idDoc, method: properties.CRUD_TYPE_GET }).then(response => {
                        });
                    }
                }

                setIsLoading(false);
            })

        } else {
            crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ANEXOS, { url: properties.URL_OBTENER_ANEXOS, method: 'post', data: input }).then(response => {

                /**
                 * Pasos a hacer en caso de que una solicitud ya tenga anexos adjuntados 
                 * 
                 * setNumAnexosObligatoriosEntregados: se setea en esta hook el número de anexos obligatorios recuperados
                 * 
                 * setNumDocumentos: seteamos este hook con la suma del numero de anexos obligatorios y optativos a entregar para actualizar
                 * el numero en la vista al usuario
                 * 
                 * Modificar informacionAnexos: es el objeto con el que se monta el componente SubirArchivo ademas de tener la informacion sobre los anexos que hay
                 * que adjuntar para la fase del procedimiento, si el anexo que recibimos coincide con un anexo Obligatorio u optativo
                 * modificamos infoAnexo para que muestre directamente el boton eliminar ya que este ya ha sido adjuntado
                 * 
                 * setDisabledListo: ponemos a false el hook que controla el disabled del boton listo
                 * 
                 * Hook documentos es el Hook que enviamos al endpoint guardarDocumentos al final del proceso, tenemos que monta ese
                 * objeto con los documentos que ya han sido anexados. De esta forma incluso cuando pulsamos eliminar la funcion eliminar
                 * anexo seguira el flujo
                 * 
                 * Para que aparezcan ya anexados en la parte de voluntarios al igual que los anexos obligatorios y optativos hay que añadir
                 * al hook documentos los anexos voluntarios montando el objeto de forma distinta a que si no fuese voluntario, a parte 
                 * hay que añadir al hook DocumentosVoluntarios los documentos voluntarios que hayamos recibido del endpoint. De esta forma
                 * cuando eliminemos uno estos anexos el flujo de la funcion eliminar seguirá sin problemas
                */
                let numAnexosOptativosRecibidos = 0;
                const arrayTemp = [];
                let contieneAnexosVoluntarios = false;
                let numInputsCreados = numInput;
                let pesoDocumentosTotal = 0;
                let anexosObligatoriosObtenidos = [];

                for (let doc of response.data) {
                    let documento = PREFIJO_OBJETO_FILE_PDF + doc.lbDocumento;

                    let pesoDocumento = parseFloat((documento.length / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES));

                    pesoDocumentosTotal = pesoDocumentosTotal + pesoDocumento;

                    if (doc.cdTipo === "AOP") {
                        numAnexosOptativosRecibidos++;
                        for (let infoAnexoOptativo of informacionAnexos.listAnexosOptativos) {
                            if (infoAnexoOptativo.descripcionAnexo === doc.dsDescripcion) {
                                infoAnexoOptativo.mostrarEliminar = true;
                                infoAnexoOptativo[properties.TAM_DOC_SUB] = pesoDocumento; //<---- Pongo el tamaño a 0 ya que no lo guardamos

                                let documentoV = {
                                    fichero: {
                                        data: doc.lbDocumento,
                                        file: {
                                            path: doc.tnombreArchivo,
                                            size: documento.length, //<---- Pongo el tamaño a 0 ya que no lo guardamos
                                        }
                                    },
                                    anexo: infoAnexoOptativo,
                                    descripcionVoluntario: null,
                                    firmado: false,
                                    nombreFichero: {
                                        path: doc.tnombreArchivo,
                                    },
                                    idSolicitud: solicitudActual.idMoaddSolicitudPdf,
                                    idConvocatoria: convocatoriaSeleccionada.id,
                                    idProcedimiento: procedimientoActual.id,
                                }

                                documentos.push(documentoV);
                            }
                        }
                    }

                    if (doc.cdTipo === "AOB") {
                        for (let infoAnexoObligatorio of informacionAnexos.listAnexosObligatorios) {
                            if (infoAnexoObligatorio.descripcionAnexo === doc.dsDescripcion) {
                                infoAnexoObligatorio.mostrarEliminar = true;
                                infoAnexoObligatorio[properties.TAM_DOC_SUB] = pesoDocumento; //<---- Pongo el tamaño a 0 ya que no lo guardamos

                                let documentoV = {
                                    fichero: {
                                        data: doc.lbDocumento,
                                        file: {
                                            path: doc.tnombreArchivo,
                                            size: documento.length, //<---- Pongo el tamaño a 0 ya que no lo guardamos
                                        }
                                    },
                                    anexo: infoAnexoObligatorio,
                                    descripcionVoluntario: null,
                                    firmado: false,
                                    nombreFichero: {
                                        path: doc.tnombreArchivo,
                                    },
                                    idSolicitud: solicitudActual.idMoaddSolicitudPdf,
                                    idConvocatoria: convocatoriaSeleccionada.id,
                                    idProcedimiento: procedimientoActual.id,
                                }
                                anexosObligatoriosObtenidos.push(documentoV);
                                documentos.push(documentoV);
                            }
                        }
                    }

                    if (doc.cdTipo === "AUS") {

                        let documentoV = {
                            fichero: {
                                data: doc.lbDocumento,
                                file: {
                                    path: doc.tnombreArchivo,
                                    size: documento.length, //<---- Pongo el tamaño a 0 ya que no lo guardamos
                                }
                            },
                            anexo: null,
                            descripcionVoluntario: doc.dsDescripcion,
                            firmado: false,
                            nombreFichero: {
                                path: doc.tnombreArchivo,
                            },
                            idSolicitud: solicitudActual.idMoaddSolicitudPdf,
                            idConvocatoria: convocatoriaSeleccionada.id,
                            idProcedimiento: procedimientoActual.id,
                        }
    
                        documentos.push(documentoV);
                        contieneAnexosVoluntarios = true;
                        let iconoDocVol= obtenerIconoDocVoluntarios(doc.tnombreArchivo);
                        numInputsCreados++;
                        let documentoVoluntario = {
                            id: Date.now(),
                            mostrarDropZone: true,
                            value: doc.dsDescripcion,
                            mostrarDocAnexo: true,
                            tamDoc: pesoDocumento,  //<---- Pongo el tamaño a 0 ya que no lo guardamos
                            img: iconoDocVol
                        }

                        arrayTemp.push(documentoVoluntario);


                    }

                }

                if (contieneAnexosVoluntarios) {

                    let documentoVoluntario = {
                        id: Date.now(),
                        mostrarDropZone: false,
                        value: "",
                        mostrarDocAnexo: false,
                        tamDoc: "",
                        img: properties.PATH_IMG_PDF
                    }

                    arrayTemp.push(documentoVoluntario);

                    setNumInput(numInputsCreados);
                    setDocumentosVoluntarios(arrayTemp);
                }
                setTamDocumentos(documentos.length === 0 ? 0 : pesoDocumentosTotal.toFixed(properties.NUMERO_DECIMALES));
                setNumAnexosObligatoriosEntregados(anexosObligatoriosObtenidos.length);
                setNumDocumentos(documentos.length);
                setInfoAnexos(informacionAnexos);
                // Se habilita el botón "Listo" si se han adjuntado todos los anexos obligatorios
                (informacionAnexos.listAnexosObligatorios.length === anexosObligatoriosObtenidos.length) && setDisabledListo(false);
            }).finally(function () {
                setIsLoading(false);
            })
        }


    }

    const obtenerIconoDocVoluntarios = (nombreFichero) =>{
        let iconoDocVol= properties.PATH_IMG_PDF;
        let extension = nombreFichero.substring(nombreFichero.lastIndexOf('.'));
        let mime = getMimeType(extension);
        if (mime && mime.startsWith('image/')) {
          iconoDocVol = properties.PATH_IMG_FOTO;
        } else if (mime && (
                            mime.startsWith('video/')||
                            mime.includes('.avi')||
                            mime.includes('.wmv')
                            )
                   ) {
          iconoDocVol = properties.PATH_IMG_VIDEO;
        }
        return iconoDocVol;
    }

    /**
     * @function recuperarTipoDocVol 
     */
    const recuperarTipoDocVol = async (codigo) => {
        let tipoDocVol;
        await crudOperation(
                crudOperationsType.CUSTOM,
                properties.RESOURCE_TIPO_DOC,
                {
                    url: properties.RESOURCE_TIPO_DOC_CODIGO + codigo,
                    method: 'GET'
                }
        ).then(response => {
            tipoDocVol = response.data;
        }).catch(() => {
            handleSetMessage(msgError.error, msgError.severity);
        });
        return tipoDocVol;
    };

    /**
     * @function obtenerFasesEstados Función que obtiene los códigos de las fases y los estados buscados
     * @returns 
     */
    const obtenerFasesEstados = async () => {
        let constantes = [];

        // Paso 1. Obtiene las constantes decalradas en BandejaSolicitudesData y se insertan en el array cosntates.
        for (const key in constantesEstadosFasePCT3) {
            constantes.push(key);
        }

        // Paso 2. Se obtienen las fases y estados 
        let fasesEstadosObtenidos = await obtenerCodigosFaseEstado(convocatoriaSeleccionada.id, constantes, constantes);

        // Paso 3. Se recorren los valores obtenidos y se insertan en las constantes que se utilizaran en la pantalla
        for (const feo of fasesEstadosObtenidos.valores) {

            switch (feo.clave) {
                case 'F_INICIO_OV3':
                    constantesEstadosFasePCT3.F_INICIO_OV3 = feo.valor;
                    break;
                case 'F_ALEGACIONES_OV3':
                    constantesEstadosFasePCT3.F_ALEGACIONES_OV3 = feo.valor;
                    break;
                case 'F_SUBSANACION_OV3':
                    constantesEstadosFasePCT3.F_SUBSANACION_OV3 = feo.valor;
                    break;
                case 'F_JUSTIFICACION_OV3':
                    constantesEstadosFasePCT3.F_JUSTIFICACION_OV3 = feo.valor;
                default:
                    break;
            }
        }
        return constantesEstadosFasePCT3;
    }

    /**
    * @function isSolicitudColaborativa Función que comprueba si se trata de una solicitud que pertenezca a un proyecto colaborativo.
    * Para que sea una solicitud colaborativa, la convocatoria debe ser colaborativa y además cuando se ha accedido a la convocatoria,
    * se ha seleccionado el perfil colaborativo.
    */
    const isSolicitudColaborativa = async () => {
        let result = false;

        if (isConvocatoriaColaborativa !== null) {
            result = isConvocatoriaColaborativa && perfilSeleccionado.descripcion === 'REPRESENTANTE_SICA';

        }

        return result;
    }

    /**
     * Carga las propiedades del backend gestion-multimedia (como formatos y tamaños) en `properties`.
     *
     */

    const getStorageProperties = async () => {
           try {
               // Utilidades internas
               const formatKey = (key) => key.toUpperCase().replace(/[^A-Z0-9_]/gi, '');
               const formatValue = (val) => val.trim();
               // Realiza la solicitud para obtener las configuraciones de almacenamiento
               const respuesta = await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ARCHIVO_MULTIMEDIA, { url: properties.RESOURCE_CONFIG_MULTIMEDIA, method: properties.CRUD_TYPE_GET });

               // Suponiendo que la respuesta tiene una propiedad 'data'
               const data = respuesta.data;

               // Procesa cada propiedad y asigna los valores a properties
               Object.keys(data).forEach((key) => {
                   // Asegúrate de aplicar el formato que necesitas a las claves y valores
                   if (key.includes('MAXIMAGE') || key.includes('MAXVIDEO')) {
                       properties[formatKey(key)] = parseInt(data[key]);
                   } else if (key.includes('ALLOWEDIMAGE') || key.includes('ALLOWEDVIDEO') || key.includes('ALLOWEDMIME')) {
                       properties[formatKey(key)] = data[key]?.split(',') ?? [];
                   } else {
                       properties[formatKey(key)] = formatValue(String(data[key]));
                   }
               });

               /** Se van a añadir en properties las siguientes variables de almacenamiento
               *
               * ALLOWEDIMAGEFORMATS: ".JPEG,.JPG,.PNG,.BMP,.WEBP"
               * ALLOWEDVIDEOFORMATS: ".MOV,.MPEG,.MP4,.MPG,.AVI,.WMV"
               * ALLOWEDMIMETYPES: "application/pdf,image/jpeg,image/png,image/bmp,image/webp,video/quicktime,video/mpeg,video/mp4,.avi,.wmv"
               * MAXIMAGESIZE: "104857600"
               * MAXIMAGESPEREXPEDIENT: "10"
               * MAXVIDEOSIZE: "524288000"
               * MAXVIDEOSPEREXPEDIENT: "3"
               *
               **/

           } catch (error) {
               console.error('Error al obtener configuración de almacenamiento', error);
               handleSetMessage({ ex: { error }, severity: 'error' });
           }
    };

    return { botonPorDefecto, alerts, message, setMessage, getInfoAnexos, infoAnexos, handleOnClickListo, listo, obtenerTituloPagina,
            tituloPagina, handleOnDrop, guardarAnexoPCT, datosTabla, isPhoneVersion, updateFormat, handleChangeIsVisible,
            isVisible, numDocumentos, tamDocumentos, mostrarPDF, cerrarPopUpPdf, pdf, handleChange, documentosVoluntarios, setDocumentosVoluntarios, eliminarAnexoVoluntario, anyadirPropiedadEliminar,
            eliminarAnexo, disabledListo, atrasFormulario, atrasOcultarTabla, numInput, isLoading, tamMaximoSobrepasado, cerrarConfirmarPeso, mostrarConfirmarError,
            cerrarErrorDropRejected, errorDropRejected, tamDropRejected, existenAnexosObligatrios, existenAnexosOptativos, recuperarAnexos,
            nombrePdfDescargar, objectButtons, setTamDocumentos, handleGuardarAnexos, mostrarConfirmacionGuardado, cerrarConfirmacionGuardado, obtenerFasesEstados, getStorageProperties
        };

}
export default useFunctions;